import routerOptions0 from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_215386922af35afe059e9f8174f699ed/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/render/project/src/apps/refresh/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}